import { DS } from '../../../../design-system'

interface BaseButtonProps {
  text: string
  onPress: () => void
  outlined?: boolean
  numberOfLines?: number
}

export const BaseButton = ({ text, onPress, outlined = false, numberOfLines }: BaseButtonProps) => {
  return (
    <DS.Button
      onPress={onPress}
      variant={outlined ? 'Large/Secondary' : 'Large/Primary'}
      type={outlined ? 'On Light' : 'On Dark'}
      {...(numberOfLines ? { numberOfLines } : {})}
    >
      {text}
    </DS.Button>
  )
}
